import React, { useEffect, useState } from "react";
const { forwardRef, useRef, useImperativeHandle } = React;

const CurrencyInput = forwardRef(
  ({ placeholder, onChange, name, inputValue, id, ...props }, ref) => {
    const [value, setValue] = useState("");

    useImperativeHandle(ref, () => ({
      afterSubmit() {
        setValue(addCommas(removeNonNumeric('')));
      },
    }));

    const addCommas = (num) =>
      num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

    const handleChange = (event) => {
      setValue(addCommas(removeNonNumeric(event.target.value)));
      onChange(removeNonNumeric(event.target.value));
    };

    useEffect(() => {
      setValue(addCommas(removeNonNumeric(inputValue ?? "")));
    }, [inputValue]);

    return (
      <div className="min-w-0">
        <input
          {...props}
          id={id || name}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          dir="ltr"
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          className="admin-field block w-full text-right"
        />
      </div>
    );
  }
);

export default CurrencyInput;
